import PropTypes from "prop-types";
import webContextProvider from "../../../../providers/webContextProvider";
import OriginalPriceInformationIcon from "../OriginalPriceInformationIcon";
import OriginalPrice from "../OriginalPrice";

const OriginalPriceMarkup = ({ originalPrice, isOutlet, previousEndDate }) => {
  const { browseCountry } = webContextProvider();

  if (browseCountry === "US") {
    return (
      <OriginalPriceInformationIcon
        originalPrice={originalPrice}
        isOutlet={isOutlet}
        previousEndDate={previousEndDate}
      />
    );
  }

  return <OriginalPrice originalPrice={originalPrice} isOutlet={isOutlet} />;
};

OriginalPriceMarkup.propTypes = {
  originalPrice: PropTypes.number,
  isOutlet: PropTypes.bool.isRequired,
  previousEndDate: PropTypes.string
};

export default OriginalPriceMarkup;
